import React from 'react';
export function TestimonialsSection() {
  const testimonials = [{
    text: 'Empecé sin saber ni templar chocolate. Hoy tengo lista de espera para el Día de la Madre. El método es clarísimo.',
    initial: 'V',
    name: 'Valentina R.',
    location: 'Rosario, Santa Fe'
  }, {
    text: 'Con el Método WhatsApp Gold cerré 8 pedidos en un fin de semana. Ahora cierro ventas sin rebajarme.',
    initial: 'M',
    name: 'Mariela G.',
    location: 'CABA, Buenos Aires'
  }, {
    text: 'Mis fotos ahora parecen de revista. El bono de fotografía me cambió la vida. Con luz natural es otro nivel.',
    initial: 'L',
    name: 'Lucía P.',
    location: 'Córdoba Capital'
  }];
  return <section className="py-10 px-5 bg-negro" data-id="element-161">
      <h2 className="font-playfair text-[clamp(22px,3.5vw,34px)] text-center text-blanco mb-6" data-id="element-162">
        Lo que dicen quienes ya lo aplicaron
      </h2>
      <div className="flex flex-col gap-4 max-w-[700px] mx-auto" data-id="element-163">
        {testimonials.map((test, i) => <div key={i} className="bg-gradient-bonus rounded-2xl p-5 border border-[rgba(201,149,108,0.2)] relative transition-all duration-300 hover:border-oro-rosa hover:-translate-y-1" data-id="element-164">
            <div className="absolute top-1 left-4 font-playfair text-[60px] text-oro-rosa opacity-30 leading-none" data-id="element-165">
              "
            </div>
            <div className="text-dorado text-[14px] mb-1 mt-1" data-id="element-166">★★★★★</div>
            <p className="text-[14px] text-[#cccccc] leading-[1.6] mb-3 italic pt-1" data-id="element-167">
              "{test.text}"
            </p>
            <div className="flex items-center gap-2" data-id="element-168">
              <div className="w-9 h-9 rounded-full bg-gradient-gold-rose flex items-center justify-center text-[16px] font-bold text-negro shrink-0" data-id="element-169">
                {test.initial}
              </div>
              <div data-id="element-170">
                <p className="text-[14px] font-bold text-dorado" data-id="element-171">{test.name}</p>
                <p className="text-[12px] text-[#888]" data-id="element-172">{test.location}</p>
              </div>
            </div>
          </div>)}
      </div>
    </section>;
}